VjsAdmin.LessonDrafts = (function () {
    const $table = $('#lesson-drafts-table');

    const me = {
        lessons: [],
        videoTopics: [],
    };

    const init = function () {
        initTable();
        getVideoTopics();
        new PublishLesson();
    };

    const resetModal = () => {
        $('#publish-date').data('DateTimePicker').clear();
        const districtSelect2 = document.querySelector('#district-search-select2');
        districtSelect2.value = '';
        districtSelect2.dispatchEvent(new Event('change'));

        const licenseSelect2 = document.querySelector('#license-search-select2');
        licenseSelect2.value = '';
        licenseSelect2.dispatchEvent(new Event('change'));
        me.lessons = [];
    };

    const PublishLesson = VjsUtility.Controller.extend({
        events: {
            'click .publish-lesson': 'publishPopup',
            'click #publish': 'publish',
            'click .vjs-popup-close-icon': 'closeModal',
            'change #archived': 'includeArchived',
            'change #premium-preview-content': 'showPremiumVideoTopicSelect',
            'click #built-in': 'typeBuiltIn',
            'click #built-in-state': 'typeBuiltInState',
            'click #custom': 'typeCustom',
        },

        includeArchived: () => {
            $table.bootstrapTable('refresh');
        },

        publish: () => {
            const chosenDate = $('#publish-date').data('DateTimePicker').viewDate();
            chosenDate.format('YYYY-MM-DD');
            chosenDate.set({
                hour: 0,
                minute: 0,
                second: 0,
                millisecond: 0,
            });
            const publishData = {
                premium: $('#premium-preview-content').is(':checked') ? 1 : 0,
                topic: $('#premium-video-topic').val(),
                date: chosenDate.toISOString(),
                lessons: me.lessons,
                districts: $('#district-search-select2')
                    .select2('data')
                    .map((item) => ({
                        district_id: item.id,
                    })),
                licenses: $('#license-search-select2')
                    .select2('data')
                    .map((item) => ({
                        license_id: item.id,
                        district_id: item.districtId,
                    })),
                states: $('#state-search-select2')
                    .select2('data')
                    .map((item) => ({
                        state_id: item.id,
                    })),
                categories: $('#category-select')
                    .select2('data')
                    .map((item) => ({
                        category: item.id,
                    })),
                social_awareness: $('#social-awareness-checkbox').is(':checked') ? 1 : 0,
            };

            const req = new VjsUtility.Request();
            req.post(Slim.Router.pathFor('content.release'), publishData)
                .done(() => {
                    VjsUtility.Notification.success({
                        text: 'Successfully Published VJS Lesson',
                        time: 3000, // in milliseconds
                    });
                    $table.bootstrapTable('refresh');
                })
                .fail(() => {
                    VjsUtility.Notification.error({
                        text: 'Publish Failed Check Console',
                        time: 5000, // in milliseconds
                    });
                })
                .always(() => {
                    // Close popup
                    me.lessons = [];
                    document.querySelector('#vjs-popup-close').click();
                });
        },

        closeModal: () => {
            resetModal();
        },

        typeBuiltIn: () => {
            $('#district-search-group').hide();
            $('#district-search-select2').val(null).trigger('change');
            $('#license-search-group').hide();
            $('#license-search-select2').val(null).trigger('change');
            $('#state-search-group').hide();
            $('#state-search-select2').val(null).trigger('change');
            $('#state-search-select2').prop('required', false);
        },
        typeBuiltInState: () => {
            $('#district-search-group').hide();
            $('#district-search-select2').val(null).trigger('change');
            $('#license-search-group').hide();
            $('#license-search-select2').val(null).trigger('change');
            $('#state-search-group').show();
            $('#state-search-select2').prop('required', true);
        },
        typeCustom: () => {
            $('#district-search-group').show();
            $('#license-search-group').show();
            $('#state-search-group').hide();
            $('#state-search-select2').val(null).trigger('change');
            $('#state-search-select2').prop('required', false);
        },

        publishPopup: (e) => {
            const currentLessonId = $(e.currentTarget).data('lessonId');
            const currentLessonName = $(e.currentTarget).data('lessonName');
            const isPremiumLesson = $(e.currentTarget).data('lessonContainsPremium');
            me.lessons.push(currentLessonId);

            VjsUtility.Popup.init({
                title: `Release Lesson: ${currentLessonName}`,
                templateUrl: '/assets/templates/content/draft-release-modal.html',
                after() {
                    const districtGroup = document.querySelector('#district-search-group');
                    const licenseGroup = document.querySelector('#license-search-group');
                    const stateGroup = document.querySelector('#state-search-group');
                    const cetegorySelectGroup = document.querySelector('#flexlesson-categories');
                    VjsAdmin.DistrictSearchSelect.init(districtGroup, []);
                    VjsAdmin.StateSearchSelect.init(stateGroup, []);
                    VjsAdmin.CategorySelect.init(cetegorySelectGroup, []);

                    const watchDistrictSelect = true;
                    VjsAdmin.LicenseSearchSelect.init(licenseGroup, [], watchDistrictSelect);
                    $('#publish-date').datetimepicker({
                        format: 'LL',
                    });
                    if (isPremiumLesson) {
                        $('#premium-preview-content').prop('checked', true);
                        $('#premium-preview-content').prop('disabled', true);
                        $('#premium-video-topic-container').show();
                        $('#premium-video-topic').prop('required', true);
                        $('#premium-notice').show();
                    }

                    me.videoTopics.forEach((d) => {
                        const option = document.createElement('option');
                        option.value = d.id;
                        option.text = d.name;
                        $('#premium-video-topic').append(option);
                    });
                },
            });
        },

        showPremiumVideoTopicSelect: (e) => {
            if (e.target.checked) {
                $('#premium-video-topic-container').show();
                $('#premium-video-topic').prop('required', true);
            } else {
                $('#premium-video-topic-container').hide();
                $('#premium-video-topic').prop('required', false);
            }
        },
    });

    const initTable = function () {
        $table.bootstrapTable({
            ...VjsTable.tableDefaults(),
            table: '#lesson-drafts-table',
            queryParams(params) {
                params.includeArchived = document.querySelector('#archived option:checked').value;

                return params;
            },
            formatNoMatches() {
                return 'No Unreleased Lessons Found';
            },

            url: Slim.Router.pathFor('content.release.drafts'),
            columns: [
                {
                    title: 'Lesson ID',
                    field: 'id',
                    align: 'center',
                    valign: 'middle',
                    sortable: false,
                    visible: false,
                },
                {
                    title: 'Lesson Name',
                    field: 'name',
                    align: 'left',
                    valign: 'middle',
                    sortable: false,
                },
                {
                    title: 'Creator',
                    field: 'creator.user_name',
                    align: 'left',
                    valign: 'middle',
                    sortable: false,
                },
                {
                    title: 'Created',
                    field: 'date_created',
                    align: 'left',
                    valign: 'middle',
                    sortable: false,
                    formatter: (val) => new Date(val).toLocaleDateString('en-US'),
                },
                {
                    title: '',
                    field: 'actions',
                    align: 'center',
                    valign: 'middle',
                    sortable: false,
                    formatter: (val, row) => `
                            <button
                                class="btn btn-primary publish-lesson"
                                data-lesson-id="${row.id}"
                                data-lesson-name="${row.name}"
                                data-lesson-contains-premium="${row.contains_premium}"
                            >
                                Release
                            </button>`,
                },
            ],
            responseHandler(res) {
                const formattedResult = {};
                formattedResult.total = res.meta.total;
                formattedResult.rows = res.data;

                return formattedResult;
            },
        });
    };

    const getVideoTopics = () => {
        $.get('/api/video-topics/', ({ data }) => {
            me.videoTopics = data.data;
        });
    };
    return {
        init,
    };
}());
